import { BaseApi } from './base.api'
import { DEFAULT_PAGE_SIZE } from '../utils/constant'

export class WordApi extends BaseApi {
	constructor() {
		super('')
	}

	async getWordWithPaging(page, pageSize = DEFAULT_PAGE_SIZE) {
		const rs = await this.get(
			`api/word/paging?orderBy=createdAt&typeSort=desc&pageNum=${page}&pageSize=${pageSize}`
		)
		return rs
	}
}
